// Maps insight-action ids to the external campaign operation they trigger.
//
// The delete / retarget-segment / swap-gift-type actions on the Offer
// Effectiveness card, and the win-back "create" action on the Loyalty Churn
// card, all route out of the PAR Intelligence drawer into the campaign-editor
// page, where the change is confirmed against the external campaign API.
//
// Action ids are deterministic and shared between the live (backend-generated)
// and seed (static) insight cards, so a single id → operation map is enough to
// wire both.

export type CampaignActionType = "delete" | "edit_segment" | "edit_promo" | "create";

export const CAMPAIGN_ACTION_BY_ID: Record<string, CampaignActionType> = {
    act_demo_promo_delete: "delete",
    act_demo_promo_segment: "edit_segment",
    act_demo_promo_promotion: "edit_promo",
    act_demo_churn_campaign: "create"
};

export function getCampaignAction(actionId: string): CampaignActionType | undefined {
    return CAMPAIGN_ACTION_BY_ID[actionId];
}
